import Vue from 'vue'
import store from '@/store/store'

// 查询融资线配置的所有银行的信息
const queryAll = () => {
  return new Promise((resolve, reject) => {
    Vue.prototype.sendGet({
      method: 'get',
      url: `/trade-center/discount-bank-quote/queryAll`
    }, (result) => {
      // 处理数据
      console.log(result.data.data)
      const changeDate = result.data.data.map((item) => {

        let cuDiscountRate = [],
          levelBankList = null;

        if (item.discountBankQuoteList) {
          // 对数据进行排序
          item.discountBankQuoteList.sort((a, b) => {
            //  承兑行等级
            if (a.acceptorType == b.acceptorType) {

              // 判断是按照什么日期排序
              if(a.dueType === 'DUE_DATE' && b.dueType === 'DUE_DATE') {
                //  剩余期限范围
                if (a.dueDate == b.dueDate) {
                  //  金额范围
                  return b.billAmountMax - a.billAmountMax;
                // } else if (new Date(a.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0]) > new Date(b.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0])) {
                } else if (a.dueDate > b.dueDate) {
                  return 1; // 交换位置
                // } else if (new Date(a.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0]) < new Date(b.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0])) {
                } else if (a.dueDate < b.dueDate) {
                  return -1;
                }
              } else if (a.dueType === 'DUE_DAY' && b.dueType === 'DUE_DAY') {
                //  剩余期限范围
                if (a.dueDayMin == b.dueDayMin) {
                  //  金额范围
                  return b.billAmountMax - a.billAmountMax;
                } else if (a.dueDayMin - b.dueDayMin > 0) {
                  return 1; // 交换位置
                } else if (a.dueDayMin - b.dueDayMin < 0) {
                  return -1;
                }
              }

            } else if (a.acceptorType - b.acceptorType > 0) {
              return 1; // 交换位置
            } else if (a.acceptorType - b.acceptorType < 0) {
              return -1; // 不交换位置
            }
          });

          item.discountBankQuoteList.map((discountBankQuote) => {
            discountBankQuote.bankLevel = discountBankQuote.acceptorType
            discountBankQuote.billRate = discountBankQuote.discountRate;
            // discountBankQuote.dueDate = `截止${discountBankQuote.dueDate}（含）`;
            if (discountBankQuote.dueType === 'DUE_DATE') {
              discountBankQuote.dueDateShow = discountBankQuote.dueDate;
            } else if (discountBankQuote.dueType === 'DUE_DAY') {
              discountBankQuote.dueDateShow = `${discountBankQuote.dueDayMin}~${discountBankQuote.dueDayMax}天`
            }
            discountBankQuote.ebillAmt = `${discountBankQuote.billAmountMax.div(10000)}${discountBankQuote.includeBillAmountMax?'≥':'>'}票面金额${discountBankQuote.includeBillAmountMin?'≥':'>'}${discountBankQuote.billAmountMin.div(10000)}`;
            return discountBankQuote
          })

          // 当前承兑行等级的列表对应的数组第几个
          let acceptBankLevelTypeList = {};

          // 当前票据类型对应数组第几个
          let draftTypeList = {};

          for (let i = 0; i < item.discountBankQuoteList.length - 1; i++) {
            if (i == 0) {
              cuDiscountRate.push(item.discountBankQuoteList[i]);
              cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
              cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i]);

              // 承兑行等级
              cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1; // 承兑行等级的总数
              acceptBankLevelTypeList[item.discountBankQuoteList[i].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
              // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList, "console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)")

            }
            
            if(item.discountBankQuoteList[i].dueType === 'DUE_DATE') {
              // dueDate
              // 比较第一个和后一个数据
              if (item.discountBankQuoteList[i].bankLevel == item.discountBankQuoteList[i + 1].bankLevel && item.discountBankQuoteList[i].dueDate == item.discountBankQuoteList[i + 1].dueDate) {
                // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);
              } else {
                // 加入新数组
                cuDiscountRate.push(item.discountBankQuoteList[i + 1]);
                cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);

                // 承兑行等级
                if (item.discountBankQuoteList[i + 1].bankLevel == cuDiscountRate[cuDiscountRate.length - 2].bankLevel) {
                  // 承兑行等级进行比较
                  // console.log(acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel], "acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel")
                  cuDiscountRate[acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel]].acceptBankLevelTypeTotal++;
                } else {
                  // 将数组的下标存入数据
                  acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
                  cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1;
                }

              }
            }else if(item.discountBankQuoteList[i].dueType === 'DUE_DAY') {
              // dueDayMax
              // 比较第一个和后一个数据
              if (item.discountBankQuoteList[i].bankLevel == item.discountBankQuoteList[i + 1].bankLevel && item.discountBankQuoteList[i].dueDayMax == item.discountBankQuoteList[i + 1].dueDayMax) {
                // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);
              } else {
                // 加入新数组
                cuDiscountRate.push(item.discountBankQuoteList[i + 1]);
                cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);

                // 承兑行等级
                if (item.discountBankQuoteList[i + 1].bankLevel == cuDiscountRate[cuDiscountRate.length - 2].bankLevel) {
                  // 承兑行等级进行比较
                  // console.log(acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel], "acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel")
                  cuDiscountRate[acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel]].acceptBankLevelTypeTotal++;
                } else {
                  // 将数组的下标存入数据
                  acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
                  cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1;
                }
              }
            }
            

          }

          levelBankList = {};
          for (let i = 0; i < item.discountBankQuoteAcceptorList.length; i++) {
            if (!levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType]) {
              levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType] = [item.discountBankQuoteAcceptorList[i].acceptName];
              // console.log(levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType], '888888888')
            } else {
              levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType].push(item.discountBankQuoteAcceptorList[i].acceptName)
            }
          }
        }

        return {
          cuDiscountRate: cuDiscountRate,
          levelBankList: levelBankList,
          logo: item.bankCode,
          bankName: item.bankName,
          updateTime: item.updateTime
        }
      })

      resolve(changeDate)
    }, (result) => {
      reject(result)
    })
  })
}

// 查询机构报价银行列表
const queryBankList =  () => {
  return new Promise((resolve,reject) => {
    Vue.prototype.sendGet({
      url:`/web/discount-bank-quote/quoteBankCode`
    },(result) => {
      console.log(result);
      resolve(result)
    },(result) => {
      reject(result)
    })
  })
}

// 刷新机构报价银行列表
const refreshBankRate = (bankCode) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.sendGet({
      method: 'get',
      url: `/web/discount-bank-quote/refresh/${bankCode}`
    }, (result) => {
      // 处理数据
      console.log(result.data.data)
      const changeDate = ((item) => {

        let cuDiscountRate = [],
          levelBankList = null;

        if (item.discountBankQuoteList) {
          // 对数据进行排序
          item.discountBankQuoteList.sort((a, b) => {
            //  承兑行等级
            if (a.acceptorType == b.acceptorType) {

              // 判断是按照什么日期排序
              if (a.dueType === 'DUE_DATE' && b.dueType === 'DUE_DATE') {
                //  剩余期限范围
                if (a.dueDate == b.dueDate) {
                  //  金额范围
                  return b.billAmountMax - a.billAmountMax;
                  // } else if (new Date(a.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0]) > new Date(b.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0])) {
                } else if (a.dueDate > b.dueDate) {
                  return 1; // 交换位置
                  // } else if (new Date(a.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0]) < new Date(b.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0])) {
                } else if (a.dueDate < b.dueDate) {
                  return -1;
                }
              } else if (a.dueType === 'DUE_DAY' && b.dueType === 'DUE_DAY') {
                //  剩余期限范围
                if (a.dueDayMin == b.dueDayMin) {
                  //  金额范围
                  return b.billAmountMax - a.billAmountMax;
                } else if (a.dueDayMin - b.dueDayMin > 0) {
                  return 1; // 交换位置
                } else if (a.dueDayMin - b.dueDayMin < 0) {
                  return -1;
                }
              }

            } else if (a.acceptorType - b.acceptorType > 0) {
              return 1; // 交换位置
            } else if (a.acceptorType - b.acceptorType < 0) {
              return -1; // 不交换位置
            }
          });

          item.discountBankQuoteList.map((discountBankQuote) => {
            discountBankQuote.bankLevel = discountBankQuote.acceptorType
            discountBankQuote.billRate = discountBankQuote.discountRate;
            // discountBankQuote.dueDate = `截止${discountBankQuote.dueDate}（含）`;
            if (discountBankQuote.dueType === 'DUE_DATE') {
              discountBankQuote.dueDateShow = discountBankQuote.dueDate;
            } else if (discountBankQuote.dueType === 'DUE_DAY') {
              discountBankQuote.dueDateShow = `${discountBankQuote.dueDayMin}~${discountBankQuote.dueDayMax}天`
            }
            discountBankQuote.ebillAmt = `${discountBankQuote.billAmountMax.div(10000)}${discountBankQuote.includeBillAmountMax ? '≥' : '>'}票面金额${discountBankQuote.includeBillAmountMin ? '≥' : '>'}${discountBankQuote.billAmountMin.div(10000)}`;
            return discountBankQuote
          })

          // 当前承兑行等级的列表对应的数组第几个
          let acceptBankLevelTypeList = {};

          // 当前票据类型对应数组第几个
          let draftTypeList = {};

          for (let i = 0; i < item.discountBankQuoteList.length - 1; i++) {
            if (i == 0) {
              cuDiscountRate.push(item.discountBankQuoteList[i]);
              cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
              cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i]);

              // 承兑行等级
              cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1; // 承兑行等级的总数
              acceptBankLevelTypeList[item.discountBankQuoteList[i].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
              // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList, "console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)")

            }

            if (item.discountBankQuoteList[i].dueType === 'DUE_DATE') {
              // dueDate
              // 比较第一个和后一个数据
              if (item.discountBankQuoteList[i].bankLevel == item.discountBankQuoteList[i + 1].bankLevel && item.discountBankQuoteList[i].dueDate == item.discountBankQuoteList[i + 1].dueDate) {
                // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);
              } else {
                // 加入新数组
                cuDiscountRate.push(item.discountBankQuoteList[i + 1]);
                cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);

                // 承兑行等级
                if (item.discountBankQuoteList[i + 1].bankLevel == cuDiscountRate[cuDiscountRate.length - 2].bankLevel) {
                  // 承兑行等级进行比较
                  // console.log(acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel], "acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel")
                  cuDiscountRate[acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel]].acceptBankLevelTypeTotal++;
                } else {
                  // 将数组的下标存入数据
                  acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
                  cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1;
                }

              }
            } else if (item.discountBankQuoteList[i].dueType === 'DUE_DAY') {
              // dueDayMax
              // 比较第一个和后一个数据
              if (item.discountBankQuoteList[i].bankLevel == item.discountBankQuoteList[i + 1].bankLevel && item.discountBankQuoteList[i].dueDayMax == item.discountBankQuoteList[i + 1].dueDayMax) {
                // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);
              } else {
                // 加入新数组
                cuDiscountRate.push(item.discountBankQuoteList[i + 1]);
                cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);

                // 承兑行等级
                if (item.discountBankQuoteList[i + 1].bankLevel == cuDiscountRate[cuDiscountRate.length - 2].bankLevel) {
                  // 承兑行等级进行比较
                  // console.log(acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel], "acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel")
                  cuDiscountRate[acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel]].acceptBankLevelTypeTotal++;
                } else {
                  // 将数组的下标存入数据
                  acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
                  cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1;
                }
              }
            }


          }

          levelBankList = {};
          for (let i = 0; i < item.discountBankQuoteAcceptorList.length; i++) {
            if (!levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType]) {
              levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType] = [item.discountBankQuoteAcceptorList[i].acceptName];
              // console.log(levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType], '888888888')
            } else {
              levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType].push(item.discountBankQuoteAcceptorList[i].acceptName)
            }
          }
        }

        return {
          cuDiscountRate: cuDiscountRate,
          levelBankList: levelBankList,
          logo: item.bankCode,
          bankName: item.bankName,
          updateTime: item.updateTime
        }
      })(result.data.data)

      resolve(changeDate)
    }, (result) => {
      reject(result)
    })
  })
}
// 查询利率表单个银行的报价
const querySingle = (bankCode) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.sendGet({
      method: 'get',
      url: `/trade-center/discount-bank-quote/queryAllBankQuote/${bankCode}`
    }, (result) => {
      // 处理数据
      console.log(result.data.data)
      const changeDate = ((item) => {

        let cuDiscountRate = [],
          levelBankList = null;

        if (item.discountBankQuoteList) {
          // 对数据进行排序
          item.discountBankQuoteList.sort((a, b) => {
            //  承兑行等级
            if (a.acceptorType == b.acceptorType) {

              // 判断是按照什么日期排序
              if(a.dueType === 'DUE_DATE' && b.dueType === 'DUE_DATE') {
                //  剩余期限范围
                if (a.dueDate == b.dueDate) {
                  //  金额范围
                  return b.billAmountMax - a.billAmountMax;
                // } else if (new Date(a.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0]) > new Date(b.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0])) {
                } else if (a.dueDate > b.dueDate) {
                  return 1; // 交换位置
                // } else if (new Date(a.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0]) < new Date(b.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0])) {
                } else if (a.dueDate < b.dueDate) {
                  return -1;
                }
              } else if (a.dueType === 'DUE_DAY' && b.dueType === 'DUE_DAY') {
                //  剩余期限范围
                if (a.dueDayMin == b.dueDayMin) {
                  //  金额范围
                  return b.billAmountMax - a.billAmountMax;
                } else if (a.dueDayMin - b.dueDayMin > 0) {
                  return 1; // 交换位置
                } else if (a.dueDayMin - b.dueDayMin < 0) {
                  return -1;
                }
              }

            } else if (a.acceptorType - b.acceptorType > 0) {
              return 1; // 交换位置
            } else if (a.acceptorType - b.acceptorType < 0) {
              return -1; // 不交换位置
            }
          });

          item.discountBankQuoteList.map((discountBankQuote) => {
            discountBankQuote.bankLevel = discountBankQuote.acceptorType
            discountBankQuote.billRate = discountBankQuote.discountRate;
            // discountBankQuote.dueDate = `截止${discountBankQuote.dueDate}（含）`;
            if (discountBankQuote.dueType === 'DUE_DATE') {
              discountBankQuote.dueDateShow = discountBankQuote.dueDate;
            } else if (discountBankQuote.dueType === 'DUE_DAY') {
              discountBankQuote.dueDateShow = `${discountBankQuote.dueDayMin}~${discountBankQuote.dueDayMax}天`
            }
            discountBankQuote.ebillAmt = `${discountBankQuote.billAmountMax.div(10000)}${discountBankQuote.includeBillAmountMax?'≥':'>'}票面金额${discountBankQuote.includeBillAmountMin?'≥':'>'}${discountBankQuote.billAmountMin.div(10000)}`;
            return discountBankQuote
          })

          // 当前承兑行等级的列表对应的数组第几个
          let acceptBankLevelTypeList = {};

          // 当前票据类型对应数组第几个
          let draftTypeList = {};

          for (let i = 0; i < item.discountBankQuoteList.length - 1; i++) {
            if (i == 0) {
              cuDiscountRate.push(item.discountBankQuoteList[i]);
              cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
              cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i]);

              // 承兑行等级
              cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1; // 承兑行等级的总数
              acceptBankLevelTypeList[item.discountBankQuoteList[i].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
              // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList, "console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)")

            }
            
            if(item.discountBankQuoteList[i].dueType === 'DUE_DATE') {
              // dueDate
              // 比较第一个和后一个数据
              if (item.discountBankQuoteList[i].bankLevel == item.discountBankQuoteList[i + 1].bankLevel && item.discountBankQuoteList[i].dueDate == item.discountBankQuoteList[i + 1].dueDate) {
                // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);
              } else {
                // 加入新数组
                cuDiscountRate.push(item.discountBankQuoteList[i + 1]);
                cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);

                // 承兑行等级
                if (item.discountBankQuoteList[i + 1].bankLevel == cuDiscountRate[cuDiscountRate.length - 2].bankLevel) {
                  // 承兑行等级进行比较
                  // console.log(acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel], "acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel")
                  cuDiscountRate[acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel]].acceptBankLevelTypeTotal++;
                } else {
                  // 将数组的下标存入数据
                  acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
                  cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1;
                }

              }
            }else if(item.discountBankQuoteList[i].dueType === 'DUE_DAY') {
              // dueDayMax
              // 比较第一个和后一个数据
              if (item.discountBankQuoteList[i].bankLevel == item.discountBankQuoteList[i + 1].bankLevel && item.discountBankQuoteList[i].dueDayMax == item.discountBankQuoteList[i + 1].dueDayMax) {
                // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);
              } else {
                // 加入新数组
                cuDiscountRate.push(item.discountBankQuoteList[i + 1]);
                cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);

                // 承兑行等级
                if (item.discountBankQuoteList[i + 1].bankLevel == cuDiscountRate[cuDiscountRate.length - 2].bankLevel) {
                  // 承兑行等级进行比较
                  // console.log(acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel], "acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel")
                  cuDiscountRate[acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel]].acceptBankLevelTypeTotal++;
                } else {
                  // 将数组的下标存入数据
                  acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
                  cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1;
                }
              }
            }
            

          }

          levelBankList = {};
          for (let i = 0; i < item.discountBankQuoteAcceptorList.length; i++) {
            if (!levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType]) {
              levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType] = [item.discountBankQuoteAcceptorList[i].acceptName];
              console.log(levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType], '888888888')
            } else {
              levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType].push(item.discountBankQuoteAcceptorList[i].acceptName)
            }
          }
        }

        return {
          cuDiscountRate: cuDiscountRate,
          levelBankList: levelBankList,
          logo: item.bankCode,
          bankName: item.bankName,
          updateTime: item.updateTime
        }
      })(result.data.data)

      resolve(changeDate)
    }, (result) => {
      reject(result)
    })
  })
}

// 查询主页银行报价
const queryShowIndexQuote = () => {
  return new Promise((resolve, reject) => {
    Vue.prototype.sendGet({
      method: 'get',
      url: `/web/discount-bank-quote/showIndexQuote`
    }, (result) => {
      // 处理数据
      console.log(result.data.data)
      resolve(result.data.data)
    }, (result) => {
      reject(result)
    })
  })
}

// 查询最优报价
const queryBest = (data) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.sendGet({
      method: 'get',
      url: `/trade-center/discount-bank-quote/bestQuote`,
      data,
    }, (result) => {
      // 处理数据
      console.log(result.data.data)
      const changeDate = ((item) => {

        let cuDiscountRate = [],
          levelBankList = null;

        if (item.discountBankQuoteList) {
          // 对数据进行排序
          item.discountBankQuoteList.sort((a, b) => {
            //  承兑行等级
            if (a.acceptorType == b.acceptorType) {

              // 判断是按照什么日期排序
              if(a.dueType === 'DUE_DATE' && b.dueType === 'DUE_DATE') {
                //  剩余期限范围
                if (a.dueDate == b.dueDate) {
                  //  金额范围
                  return b.billAmountMax - a.billAmountMax;
                // } else if (new Date(a.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0]) > new Date(b.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0])) {
                } else if (a.dueDate > b.dueDate) {
                  return 1; // 交换位置
                // } else if (new Date(a.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0]) < new Date(b.dueDate.match(/\d{4}\/\d{2}\/\d{2}/g)[0])) {
                } else if (a.dueDate < b.dueDate) {
                  return -1;
                }
              } else if (a.dueType === 'DUE_DAY' && b.dueType === 'DUE_DAY') {
                //  剩余期限范围
                if (a.dueDayMin == b.dueDayMin) {
                  //  金额范围
                  return b.billAmountMax - a.billAmountMax;
                } else if (a.dueDayMin - b.dueDayMin > 0) {
                  return 1; // 交换位置
                } else if (a.dueDayMin - b.dueDayMin < 0) {
                  return -1;
                }
              }

            } else if (a.acceptorType - b.acceptorType > 0) {
              return 1; // 交换位置
            } else if (a.acceptorType - b.acceptorType < 0) {
              return -1; // 不交换位置
            }
          });

          item.discountBankQuoteList.map((discountBankQuote) => {
            discountBankQuote.bankLevel = discountBankQuote.acceptorType
            discountBankQuote.billRate = discountBankQuote.discountRate;
            // discountBankQuote.dueDate = `截止${discountBankQuote.dueDate}（含）`;
            if (discountBankQuote.dueType === 'DUE_DATE') {
              discountBankQuote.dueDateShow = discountBankQuote.dueDate;
            } else if (discountBankQuote.dueType === 'DUE_DAY') {
              // 日期加减处理
              const dateChange = function  (num = 1, date = false) {
                // console.log(num, date);
                if (!date) {
                  date = new Date();//没有传入值时,默认是当前日期
                  date = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
                }
                date += " 00:00:00";//设置为当天凌晨12点
                date = Date.parse(new Date(date)) / 1000;//转换为时间戳
                date += (86400) * num;//修改后的时间戳
                var newDate = new Date(parseInt(date) * 1000);//转换为时间
                return newDate.getFullYear() + '/' + (newDate.getMonth() + 1) + '/' + newDate.getDate();
              }
              discountBankQuote.dueDateShow = discountBankQuote.dueDayMin == '0' ? `今日至${dateChange(discountBankQuote.dueDayMax)}` : `${dateChange(discountBankQuote.dueDayMin) }至${dateChange(discountBankQuote.dueDayMax)}`

            }
            discountBankQuote.ebillAmt = `${discountBankQuote.billAmountMax.div(10000)}${discountBankQuote.includeBillAmountMax?'≥':'>'}票面金额${discountBankQuote.includeBillAmountMin?'≥':'>'}${discountBankQuote.billAmountMin.div(10000)}`;
            return discountBankQuote
          })

          // 当前承兑行等级的列表对应的数组第几个
          let acceptBankLevelTypeList = {};

          // 当前票据类型对应数组第几个
          let draftTypeList = {};

          for (let i = 0; i < item.discountBankQuoteList.length - 1; i++) {
            if (i == 0) {
              cuDiscountRate.push(item.discountBankQuoteList[i]);
              cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
              cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i]);

              // 承兑行等级
              cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1; // 承兑行等级的总数
              acceptBankLevelTypeList[item.discountBankQuoteList[i].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
              // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList, "console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)")

            }
            
            if(item.discountBankQuoteList[i].dueType === 'DUE_DATE') {
              // dueDate
              // 比较第一个和后一个数据
              if (item.discountBankQuoteList[i].bankLevel == item.discountBankQuoteList[i + 1].bankLevel && item.discountBankQuoteList[i].dueDate == item.discountBankQuoteList[i + 1].dueDate) {
                // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);
              } else {
                // 加入新数组
                cuDiscountRate.push(item.discountBankQuoteList[i + 1]);
                cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);

                // 承兑行等级
                if (item.discountBankQuoteList[i + 1].bankLevel == cuDiscountRate[cuDiscountRate.length - 2].bankLevel) {
                  // 承兑行等级进行比较
                  // console.log(acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel], "acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel")
                  cuDiscountRate[acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel]].acceptBankLevelTypeTotal++;
                } else {
                  // 将数组的下标存入数据
                  acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
                  cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1;
                }

              }
            }else if(item.discountBankQuoteList[i].dueType === 'DUE_DAY') {
              // dueDayMax
              // 比较第一个和后一个数据
              if (item.discountBankQuoteList[i].bankLevel == item.discountBankQuoteList[i + 1].bankLevel && item.discountBankQuoteList[i].dueDayMax == item.discountBankQuoteList[i + 1].dueDayMax) {
                // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);
              } else {
                // 加入新数组
                cuDiscountRate.push(item.discountBankQuoteList[i + 1]);
                cuDiscountRate[cuDiscountRate.length - 1].arrayList = [];
                cuDiscountRate[cuDiscountRate.length - 1].arrayList.push(item.discountBankQuoteList[i + 1]);

                // 承兑行等级
                if (item.discountBankQuoteList[i + 1].bankLevel == cuDiscountRate[cuDiscountRate.length - 2].bankLevel) {
                  // 承兑行等级进行比较
                  // console.log(acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel], "acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel")
                  cuDiscountRate[acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel]].acceptBankLevelTypeTotal++;
                } else {
                  // 将数组的下标存入数据
                  acceptBankLevelTypeList[item.discountBankQuoteList[i + 1].bankLevel] = cuDiscountRate.length - 1; // 将数组的下标存入数据
                  cuDiscountRate[cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1;
                }
              }
            }
            

          }

          levelBankList = {};
          for (let i = 0; i < item.discountBankQuoteAcceptorList.length; i++) {
            if (!levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType]) {
              levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType] = [item.discountBankQuoteAcceptorList[i].acceptName];
              // console.log(levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType], '888888888')
            } else {
              levelBankList[item.discountBankQuoteAcceptorList[i].acceptorType].push(item.discountBankQuoteAcceptorList[i].acceptName)
            }
          }
        }

        return {
          cuDiscountRate: cuDiscountRate,
          levelBankList: levelBankList,
          logo: item.bankCode,
          bankName: item.bankName,
          updateTime: result.data.data.updateTime
        }
      })({
        bankCode: 'other',
        bankName: '最优报价',
        discountBankQuoteAcceptorList: [],
        discountBankQuoteList: result.data.data.discountBankQuoteList.map(item => {
          item.dueType = 'DUE_DAY'
          return item
        })
      })

      resolve(changeDate)
    }, (result) => {
      reject(result)
    })
  })
}


export {
  queryAll,
  queryBankList,
  refreshBankRate,
  querySingle,
  queryShowIndexQuote,
  queryBest
}



// WEBPACK FOOTER //
// ./src/api/discountBankQuote.js